
    <fieldmagic-dialog
      icon="import"
      label="Import Asset Types"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          [disabled]="initializing$ | async"
          label="Import"
          icon="import"
          (click)="onImport()"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div
          *ngIf="(initializing$ | async) || (importing$ | async)"
          class="d-flex d-flex-gap flex-column align-items-center justify-content-center w-100"
        >
          <fieldmagic-icon [spin]="true"></fieldmagic-icon>
          <fieldmagic-text [content]="progress$ | async | translate"></fieldmagic-text>
        </div>

        <div
          *ngIf="(! (initializing$ | async) && ! (importing$ | async))"
          class="d-flex d-flex-gap flex-column w-100"
        >
          <fieldmagic-dropdown-input
            [(ngModel)]="template"
            label="Please select a standard template to use"
            placeholder="Please select a standard template to use"
            [options]="templates$ | async"
            [withRequiredMarker]="true"
            (ngModelChange)="onTemplateChange()"
          >
          </fieldmagic-dropdown-input>

          <ng-container *ngIf="template | filled">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td>
                    <fieldmagic-text
                      purpose="table-header"
                      content="Asset Type"
                    >
                    </fieldmagic-text>
                  </td>
                  <td
                    *ngIf="(! (fetching$ | async)) && (assetTypes$ | async | filled)"
                  >
                    <fieldmagic-checkbox-input
                      [(ngModel)]="all"
                      [useNative]="true"
                      tooltip="Click to select/unselect all"
                      (ngModelChange)="onSelectAll($event)"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngIf="fetching$ | async">
                  <tr class="text-center">
                    <td colspan="2">
                      <fieldmagic-icon
                        [spin]="true"
                        position="center"
                      >
                      </fieldmagic-icon>
                    </td>
                  </tr>
                </ng-container>

                <ng-container *ngIf="! (fetching$ | async)">
                  <tr *ngIf="assetTypes$ | async | blank">
                    <td
                      class="text-center"
                      colspan="2"
                    >
                      {{ 'No asset types to import. Please select a different template.' | translate }}
                    </td>
                  </tr>
                  <tr *ngFor="let asset_type of (assetTypes$ | async); let asset_type_index = index;">
                    <td>{{ asset_type.name }}</td>
                    <td width="2%">
                      <fieldmagic-checkbox-input
                        [(ngModel)]="asset_type.included"
                        [useNative]="true"
                        tooltip="Click to select/unselect"
                        (ngModelChange)="onSelect($event, asset_type_index)"
                      >
                      </fieldmagic-checkbox-input>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  